module.exports = __webpack_public_path__ + "static/media/wand.818f4403.svg";